/* eslint-disable  */

import React, { useEffect, useMemo, useState } from 'react';
import { App, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ComptrollerDataTable from 'pages/comptroller/comptroller-table/ComptrollerDataTable';
import { IdentityFeaturedTable } from 'pages/IdentityCase/Table';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { useGetSolutionNameMutation, useIdentityBulkMutation } from 'store/features/process/processApi';
import { groupBy } from 'lodash';
import { toastConfig } from 'config';
import controls from 'assets/images/icons/deactivated.svg';
import { activeInactiveStatus } from 'pages/globals/global';

const ListViewLeaseManagementArea = ({
	leaseList = [],
	isLoading,
	selectedTabName = 'All',
	currentRoute = 'v6',
	isRowClick = true,
	setData,
	processDetails: passedProcessDetails,
	permissionsObject = null,
	headMetaData = null,
	expectedURLToRedirect = null,
	setRefresh = () => {},
	refetchData = () => {},
}) => {
	const { message: messageApi } = App.useApp();
	// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ ListViewLeaseManagementArea ~ selectedTabName:', selectedTabName);
	const navigate = useNavigate();
	const [submitData, setSubmitData] = useState(null);
	const [rowSelection, setRowSelection] = useState([]);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [modalData, setModalData] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [minLoading, setMinLoading] = useState(true);
	const { state } = useLocation();
	const [GetSolutionName, { data: processDetails, isSuccess: isProcessDetailsSuccess, isLoading: isProcessDetailsLoading }] =
		useGetSolutionNameMutation();
	const [IdentityBulk, { data: activationData, isSuccess: isCaseSuccess, isLoading: isCaseLoading, isError: isCaseError }] =
		useIdentityBulkMutation();

	// Use passed processDetails if available, otherwise use the one from API
	const currentProcessDetails = passedProcessDetails || processDetails;

	// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ ListViewLeaseManagementArea ~ selectedTabName:', selectedTabName);

	// Get route paths based on version
	const getRoutePaths = () => {
		// const basePath = `/static/lease-record-management-${currentRoute}`;
		const basePath = `/static/decommission-asset`;

		return {
			details: `${basePath}/details`,
			edit: `${basePath}/edit`,
			list: `${basePath}/MzEwMQ`, // Default route ID
		};
	};

	useEffect(() => {
		if (rowSelection?.length) {
			let arr = [];

			rowSelection?.forEach((item) => {
				arr.push(item.original);
			});

			setSelectedRowKeys(groupBy(arr, ({ activationStatus }) => activationStatus));
		}
	}, [rowSelection]);

	useEffect(() => {
		if (isCaseSuccess) {
			if (activationData?.successCount > 0) {
				toast.success(`Success! ${activationData?.successCount} Action completed`, toastConfig);
			}

			if (activationData?.failedCount > 0) {
				toast.error(`Failed! ${activationData?.failedCount} Action incomplete`, toastConfig);
			}

			// Refetch data after successful operations for proper sync
			setRefresh((prev) => !prev);
			refetchData();
		} else if (isCaseError) {
			toast.error(`${currentProcessDetails?.name} status updating error!`, toastConfig);
		}

		setSelectedRowKeys([]);
		setRowSelection({});
		setSubmitData(null);
	}, [isCaseError, isCaseSuccess, setRefresh, refetchData]);

	const routes = getRoutePaths();

	useEffect(() => {
		if (state?.processCode) {
			GetSolutionName({
				code: state?.processCode,
			});
		} else if (!passedProcessDetails) {
			navigate(-1);
		}
		// eslint-disable-next-line
	}, []);

	// Clear selection when tab changes
	useEffect(() => {
		setRowSelection([]);
	}, [selectedTabName]);

	// Add useEffect for minimum loading time
	useEffect(() => {
		const timer = setTimeout(() => {
			setMinLoading(false);
		}, 100);

		return () => clearTimeout(timer);
	}, []);

	function hasGlKey(data) {
		return Object.keys(data).some((key) => key.startsWith('gl_'));
	}

	// Static column definitions with react-table v7 selection pattern for ComptrollerDataTable
	const COLUMNS = useMemo(
		() => [
			{
				id: 'Selection',
				Header: ({ getToggleAllRowsSelectedProps }) => (
					<IndeterminateCheckbox sx={{ color: '#858585', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
				),
				Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
				onClicked: true,
				align: 'center',
				cellAlign: 'center',
			},
			{
				Header: 'Decommission Id',
				accessor: (row) => row.data?.decommissionId || 'N/A',
			},
			// {
			// 	Header: 'Lease Description',
			// 	accessor: (row) => row.data?.retirementTitle || row.retirementTitle || 'N/A',
			// },
			{
				Header: 'Retirement Start Date',
				accessor: (row) => {
					const startDate = row.data?.retirementStartDate;
					return startDate ? startDate.split('T')[0] : 'N/A';
				},
			},
			// {
			// 	Header: 'Lease End Date',
			// 	accessor: (row) => {
			// 		const endDate = row.data?.leaseEndDate || row.leaseEndDate;
			// 		return endDate ? endDate.split('T')[0] : 'N/A';
			// 	},
			// },
			{
				Header: 'Retirement Cost',
				accessor: (row) => {
					const cost = row.data?.retirementCost;
					return cost ? `${cost}` : 'N/A';
				},
			},
			// {
			// 	Header: 'Payment Modality',
			// 	accessor: (row) => {
			// 		const value = row.data?.paymentModality || row.paymentModality;
			// 		return value === 'Start' ? 'Advance Basis' : 'Accrual Basis';
			// 	},
			// },
			// {
			// 	Header: 'Payment Frequency',
			// 	accessor: (row) => row.data?.paymentFrequency || row.paymentFrequency || 'N/A',
			// },
			// {
			// 	Header: 'Initial Discount Rate',
			// 	accessor: (row) => {
			// 		const rate = row.data?.initialDiscountRate || row.initialDiscountRate;
			// 		return rate ? `${rate}` : 'N/A';
			// 	},
			// },
			// {
			// 	Header: 'GL Assignment',
			// 	accessor: (row) => {
			// 		if (hasGlKey(row?.data)) {
			// 			return 'Complete';
			// 		}
			// 		return 'Incomplete';
			// 	},
			// 	Cell: ({ value }) => activeInactiveStatus(value),
			// },
			// {
			// 	Header: 'CC Assignment',
			// 	accessor: (row) => {
			// 		const ccAssignment = row.data?.refCCAssignmentIdentityId || row.refCCAssignmentIdentityId;
			// 		if (ccAssignment?.date) {
			// 			return 'Complete';
			// 		}
			// 		return 'Incomplete';
			// 	},
			// 	Cell: ({ value }) => activeInactiveStatus(value),
			// },
			// {
			// 	Header: 'Agreement Uploaded',
			// 	accessor: (row) => {
			// 		const agreementFiles = row.data?.agreementFiles || row.agreementFiles;
			// 		return agreementFiles && agreementFiles.length > 0 ? 'Complete' : 'Incomplete';
			// 	},

			// 	Cell: ({ value }) => (value === 'Complete' ? activeInactiveStatus(value) : activeInactiveStatus(`${value}WithWarning`)),
			// },
			{
				Header: 'Status',
				accessor: (row) => row.activationStatus || 'N/A',
				Cell: ({ value }) => {
					return activeInactiveStatus(value);
				},
			},
		],
		[]
	);

	// TanStack Table column definitions for IdentityFeaturedTable
	const TANSTACK_COLUMNS = useMemo(
		() => [
			{
				id: 'Selection',
				header: ({ table }) => (
					<IndeterminateCheckbox
						{...{
							checked: table.getIsAllRowsSelected(),
							indeterminate: table.getIsSomeRowsSelected(),
							onChange: table.getToggleAllRowsSelectedHandler(),
							sx: { color: '#858585', padding: '0px' },
						}}
					/>
				),
				cell: ({ row }) => (
					<IndeterminateCheckbox
						{...{
							checked: row.getIsSelected(),
							disabled: !row.getCanSelect(),
							indeterminate: row.getIsSomeSelected(),
							onChange: row.getToggleSelectedHandler(),
						}}
					/>
				),
				meta: {
					style: { textAlign: 'center', width: '57px' },
				},
				enableSorting: false,
				enableColumnFilter: false,
			},
			{
				header: 'Decommission Id',
				accessorKey: 'decommissionId',
				accessorFn: (row) => row.data?.decommissionId || 'N/A',
				dataType: 'text',
				enableColumnFilter: true,
			},
			// {
			// 	header: 'Lease Description',
			// 	accessorKey: 'retirementTitle',
			// 	accessorFn: (row) => row.data?.retirementTitle || row.retirementTitle || 'N/A',
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			{
				header: 'Retirement Start Date',
				accessorKey: 'retirementStartDate',
				accessorFn: (row) => {
					const startDate = row.data?.retirementStartDate || row.retirementStartDate;
					// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ startDate :', startDate);
					// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ startDate T:', startDate.split('T')[0]);
					return startDate ? startDate.split('T')[0] : 'N/A';
				},
				dataType: 'text',
				enableColumnFilter: true,
			},
			// {
			// 	header: 'Lease End Date',
			// 	accessorKey: 'leaseEndDate',
			// 	accessorFn: (row) => {
			// 		const endDate = row.data?.leaseEndDate || row.leaseEndDate;
			// 		return endDate ? endDate.split('T')[0] : 'N/A';
			// 	},
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			{
				header: 'Retirement Cost',
				accessorKey: 'retirementCost',
				accessorFn: (row) => {
					const term = row.data?.retirementCost;
					return term ? `${term}` : 'N/A';
				},
				dataType: 'text',
				enableColumnFilter: true,
			},
			// {
			// 	header: 'Payment Modality',
			// 	accessorKey: 'paymentModality',
			// 	accessorFn: (row) => {
			// 		const value = row.data?.paymentModality || row.paymentModality;
			// 		return value === 'Start' ? 'Advance Basis' : 'Accrual Basis';
			// 	},
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			// {
			// 	header: 'Payment Frequency',
			// 	accessorKey: 'paymentFrequency',
			// 	accessorFn: (row) => row.data?.paymentFrequency || row.paymentFrequency || 'N/A',
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			// {
			// 	header: 'Initial Discount Rate',
			// 	accessorKey: 'initialDiscountRate',
			// 	accessorFn: (row) => {
			// 		const rate = row.data?.initialDiscountRate || row.initialDiscountRate;
			// 		return rate ? `${rate}` : 'N/A';
			// 	},
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			// {
			// 	header: 'GL Assignment',
			// 	accessorKey: 'glAssignment',
			// 	accessorFn: (row) => {
			// 		if (hasGlKey(row?.data)) {
			// 			return 'Complete';
			// 		}
			// 		return 'Incomplete';
			// 	},
			// 	cell: ({ getValue }) => activeInactiveStatus(getValue()),
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			// {
			// 	header: 'CC Assignment',
			// 	accessorKey: 'ccAssignment',
			// 	accessorFn: (row) => {
			// 		const ccAssignment = row.data?.refCCAssignmentIdentityId || row.refCCAssignmentIdentityId;
			// 		if (ccAssignment?.date) {
			// 			return 'Complete';
			// 		}
			// 		return 'Incomplete';
			// 	},
			// 	cell: ({ getValue }) => activeInactiveStatus(getValue()),
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			// {
			// 	header: 'Agreement Uploaded',
			// 	accessorKey: 'agreementUploaded',
			// 	accessorFn: (row) => {
			// 		const agreementFiles = row.data?.agreementFiles || row.agreementFiles;
			// 		return agreementFiles && agreementFiles.length > 0 ? 'Complete' : 'Incomplete';
			// 	},
			// 	cell: ({ getValue }) => {
			// 		const value = getValue();
			// 		return value === 'Complete' ? activeInactiveStatus(value) : activeInactiveStatus(`${value}WithWarning`);
			// 	},
			// 	dataType: 'text',
			// 	enableColumnFilter: true,
			// },
			{
				header: 'Status',
				accessorKey: 'activationStatus',
				accessorFn: (row) => row.activationStatus || 'N/A',
				cell: ({ getValue }) => activeInactiveStatus(getValue()),
				dataType: 'text',
				enableColumnFilter: true,
			},
		],
		[]
	);

	// Handle row click - similar to navigateToDetails in IdentityCaseList
	const navigateToDetails = (row) => {
		navigate(routes.details, {
			state: {
				leaseDetails: row,
				leaseList,
				selectedTab: selectedTabName,
				_id: row._id || row.id,
				processCode: '10113',
				processName: currentProcessDetails?.name,
			},
			// state: {
			// 	leaseDetails: row,
			// 	leaseList,
			// 	selectedTab: selectedTabName,
			// 	_id: row._id || row.id,
			// 	processCode: '10113',
			// 	processName: 'Lease Records',
			// },
		});
	};

	// Handle row click for ComptrollerDataTable
	const handleRowClick = (row) => {
		navigateToDetails(row);
	};

	// Handle row selection for IdentityFeaturedTable
	const handleSelectRow = (row) => {
		if (headMetaData?.meta?.staticFormUrl?.startsWith('/static/') || permissionsObject?.write === true) {
			const url = headMetaData?.meta?.staticFormUrl ?? '/case-identity';
			const staticURL = headMetaData?.meta?.staticFormUrl;

			if (staticURL) {
				navigate(`${url}/details`, {
					state: {
						processCode: currentProcessDetails?.processCode,
						processName: currentProcessDetails?.name,
						_id: row?.id || row?._id,
						leaseDetails: row,
						leaseList,
						selectedTab: selectedTabName,
					},
				});
			} else {
				navigateToDetails(row);
			}
		} else {
			navigateToDetails(row);
		}
	};

	// Column filter function similar to IdentityCaseList
	const renderColumnForTab = (selectedTab) => {
		// For ComptrollerDataTable, filter columns based on tab if needed
		const data = COLUMNS.filter((column) => {
			if (column?.tabs && selectedTab && column?.tabs?.includes(selectedTab)) {
				return false;
			} else {
				return true;
			}
		});

		return data;
	};

	// TanStack column filter function for IdentityFeaturedTable
	const renderTanStackColumnForTab = (selectedTab) => {
		const data = TANSTACK_COLUMNS.filter((column) => {
			if (column?.tabs && selectedTab && column?.tabs?.includes(selectedTab)) {
				return false;
			} else {
				return true;
			}
		});

		return data;
	};

	// Approve/Reject handler for IdentityFeaturedTable
	const approveRejectHandler = (data, status) => {
		const arr = [];
		const ids = [];

		if (Array.isArray(data)) {
			data?.forEach((item) => {
				if (item?.recordStatus === 'parked') {
					ids.push(item.id || item._id);
				} else {
					arr.push(item);
				}
			});
		} else {
			if (data?.recordStatus === 'parked') {
				ids.push(data);
			} else {
				arr.push(data);
			}
		}

		if (arr?.length > 0) {
			messageApi.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setModalData({
				head: currentProcessDetails?.name,
				action: status,
				label:
					ids?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>{status}</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>{status}</b>
							{!status?.includes('?') ? '?' : ''}
						</p>
					),
			});

			setSubmitData(ids);
			setShowModal(true);
		}
	};

	const activeDeactivateHandle = (status) => {
		// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ activeDeactivateHandle ~ selectedRowKeys:', selectedRowKeys, 'status', status);
		let arr = [];
		const recordStatusArr = [];

		if (status === 'Active') {
			//////////////// // called when deactive button is clicked
			setModalData({
				head: currentProcessDetails?.name,
				action: 'Inactive',
				label:
					rowSelection?.length > 1 ? (
						<p>
							{' '}
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>deactivate</b> this {currentProcessDetails?.name?.toLowerCase()}?
						</p>
					),
			});

			if (selectedRowKeys[status]) {
				selectedRowKeys[status]?.map((item) => {
					arr.push({
						_id: item?._id,
					});
					// checked is there any parked data inside.
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
					return item;
				});
			}
		} else if (status === 'Inactive') {
			setModalData({
				head: currentProcessDetails?.name,
				action: 'Active',
				label:
					rowSelection?.length > 1 ? (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> all?
						</p>
					) : (
						<p>
							Do you want to <b style={{ fontSize: '1rem' }}>active</b> this {currentProcessDetails?.name?.toLowerCase()}?
						</p>
					),
			});

			if (selectedRowKeys[status]) {
				selectedRowKeys[status]?.forEach((item) => {
					arr.push({
						_id: item?._id,
					});
					// checked is there any parked data inside.
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			} else if (selectedRowKeys['W-I-P']) {
				selectedRowKeys['W-I-P']?.forEach((item) => {
					arr.push({
						_id: item?._id,
					});
					// checked is there any parked data inside.
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			} else if (selectedRowKeys['null']) {
				selectedRowKeys['null']?.forEach((item) => {
					arr.push({
						_id: item?._id,
					});
					// checked is there any parked data inside.
					if (item?.recordStatus === 'parked') {
						recordStatusArr.push(item);
					}
				});
			}
		} else if (status === 'Save') {
			setModalData({
				head: currentProcessDetails?.name,
				action: 'Save',
				label: (
					<p>
						Do you want to <b style={{ fontSize: '1rem' }}>Save</b> all?
					</p>
				),
			});

			if (selectedRowKeys['Drafts']) {
				selectedRowKeys['Drafts']?.map((item) => {
					arr.push({ ...item?.data, identityDraftId: item?.id });
				});
			}
		}

		// console.log('ÃƒÂ°Ã…Â¸Ã…Â¡Ã¢â€šÂ¬ ~ activeDeactivateHandle ~ arr:', arr);
		if (arr?.length !== rowSelection?.length || recordStatusArr?.length > 0) {
			messageApi.error({
				content: 'Your request is inconsistent with selection.',
				icon: <img src={controls} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		} else {
			setSubmitData(arr);
			setShowModal(true);
		}
	};

	const modalSubmitHandler = () => {
		if (modalData?.action === 'Active') {
			const payload = {
				_id: submitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: currentProcessDetails?.processCode,
				activationStatus: 'Active',
			};

			IdentityBulk(payload);
		} else if (modalData?.action === 'Inactive') {
			const payload = {
				_id: submitData.map((item) => item._id),
				operation: 'activate-bulk',
				processCode: currentProcessDetails?.processCode,
				activationStatus: 'Inactive',
			};

			IdentityBulk(payload);
		} else if (modalData?.action === 'Approve') {
			IdentityBulk({
				_id: submitData,
				operation: 'approve-bulk',
				processCode: currentProcessDetails.processCode,
				suffixCode: '',
			});
		} else if (modalData?.action === 'Reject') {
			IdentityBulk({
				_id: submitData,
				operation: 'reject-bulk',
				processCode: currentProcessDetails.processCode,
			});
		} else if (modalData?.action === 'Save') {
			IdentityBulk({
				data: submitData,
				operation: 'add-bulk',
				processCode: currentProcessDetails.processCode,
			});
		}
	};

	console.log(state, 'state');

	return (
		<Spin spinning={isLoading || minLoading}>
			{isRowClick ? (
				<ComptrollerDataTable
					selectedTabName={selectedTabName}
					DATA={leaseList}
					COLUMNS={renderColumnForTab(selectedTabName)}
					setRowSelection={setRowSelection}
					rowSelection={rowSelection}
					onClickHandler={navigateToDetails}
					activeDeactivateHandle={activeDeactivateHandle}
					xlsxFileName={currentProcessDetails?.name || 'lease-records'}
					bulkDelete={false}
					balkAction={true}
				/>
			) : (
				<IdentityFeaturedTable
					columns={renderTanStackColumnForTab(selectedTabName)}
					setData={setData}
					rowSelection={rowSelection}
					processDetails={currentProcessDetails}
					xlsxFileName={currentProcessDetails?.name || 'lease-records'}
					setRowSelection={setRowSelection}
					data={leaseList ?? []}
					approveRejectHandler={approveRejectHandler}
					activeDeactivateHandle={activeDeactivateHandle}
					selectedTabName={selectedTabName}
					expectedURLToRedirect={expectedURLToRedirect}
					handleSelectRow={handleSelectRow}
				/>
			)}
			{showModal && (
				<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} modalData={modalData} handleSubmit={modalSubmitHandler} />
			)}
		</Spin>
	);
};

export default ListViewLeaseManagementArea;